import React, { useContext } from 'react';
import { DateTime } from 'luxon';

import { media } from 'context';
import { Layout, Text, Icon } from 'ds';
import { titleize } from 'shared';

import { WeatherWidgetData } from './types';
import { getWeatherIconName } from './weatherIconMapping';

interface Props {
  data: WeatherWidgetData;
}

const WeatherWidget: React.FC<Props> = ({ data: { current, daily, address } }) => {
  const { isMobile } = useContext(media);

  if (isMobile) {
    return (
      <Layout
        width="100%"
        height="100%"
        color="white"
        padding={12}
        borderRadius={16}
        direction="column"
        justify="space-between"
      >
        <Layout direction="row" justify="space-between" align="center">
          <Layout gap={4} align="center">
            <Icon name={getWeatherIconName(current.weather[0].icon)} size="md" color="gray-900" />
            <Text size="body-sm">{Math.round(current.temp)}°F</Text>
          </Layout>
          <Text size="body-sm" color="gray-700">
            {titleize(current.weather[0].description)}
          </Text>
        </Layout>
        <Layout direction="row" justify="space-between" gap={4} maxWidth={143}>
          <Text size="body-xs" color="gray-700" ellipsis>
            {address.city}
          </Text>
          <Layout direction="row" gap={4}>
            <Text size="body-xs" color="gray-400" wrap={false}>
              H: {Math.round(daily[0].temp.max)}°
            </Text>
            <Text size="body-xs" color="gray-400" wrap={false}>
              L: {Math.round(daily[0].temp.min)}°
            </Text>
          </Layout>
        </Layout>
      </Layout>
    );
  }

  return (
    <Layout
      borderRadius={16}
      height="100%"
      color="white"
      paddingY={12}
      paddingX={16}
      direction="column"
      justify="space-between"
    >
      <Layout direction="column">
        <Layout justify="space-between" align="center">
          <Layout align="center" gap={8}>
            <Icon name={getWeatherIconName(current.weather[0].icon)} size="xl" color="gray-900" />
            <Text size="body-md">{Math.round(current.temp)}°F</Text>
          </Layout>
          <Text size="body-xs" color="gray-700">
            {titleize(current.weather[0].description)}
          </Text>
        </Layout>
        <Layout justify="space-between">
          <Text size="body-xs" color="gray-700">
            {address.city}
          </Text>
          <Layout gap={4}>
            <Text size="body-xs" color="gray-400">
              H: {Math.round(daily[0].temp.max)}°
            </Text>
            <Text size="body-xs" color="gray-400">
              L: {Math.round(daily[0].temp.min)}°
            </Text>
          </Layout>
        </Layout>
      </Layout>
      <Layout justify="space-between" align="center">
        {daily.slice(0, 5).map(({ temp: { max }, dt, weather: weathers }) => {
          const weather = weathers[0];

          return (
            <Layout key={dt} direction="column" align="center" gap={4}>
              <Icon name={getWeatherIconName(weather.icon)} size="md" color="gray-900" />
              <Layout direction="column" gap={2}>
                <Text size="body-xs">{Math.round(max)}°</Text>
                <Text size="body-xs" color="gray-400">
                  {DateTime.fromSeconds(dt).toLocaleString({ weekday: 'short' })}
                </Text>
              </Layout>
            </Layout>
          );
        })}
      </Layout>
    </Layout>
  );
};

export default WeatherWidget;
